import { render, staticRenderFns } from "./changelog_manage.vue?vue&type=template&id=1e35365e&"
import script from "./changelog_manage.vue?vue&type=script&lang=js&"
export * from "./changelog_manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports